import { zodResolver } from '@hookform/resolvers/zod'
import { useStoreMap } from 'effector-react'
import { useForm } from 'react-hook-form'
import { driverModel } from '~/entities/Driver'
import { taxSystemEnumOptions } from '~/shared/config/constants'
import { Button } from '~/shared/ui/Buttons'
import { FormProvider, Select, TextInput } from '~/shared/ui/form'
import { formSchema, FormValues } from './model'
import { Wrapper } from './styled'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Form({ onSuccess, isSubmitting }: FormProps) {
  const driverEmail = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getEmail(),
  )

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: { email: driverEmail },
  })

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Wrapper>
        <TextInput name='email' label='Email' disabled={isSubmitting} />

        <Select
          options={taxSystemEnumOptions}
          name='taxSystem'
          label='Система налогообложения ип'
          modalTitle='Система налогообложения ип'
          disabled={isSubmitting}
        />

        <TextInput name='inn' label='ИНН' disabled={isSubmitting} />

        <Button
          fullWidth
          type='submit'
          size='large'
          variant='limeFlooded'
          style={{ marginTop: '26px' }}
          loading={isSubmitting}
        >
          Подтвердить
        </Button>
      </Wrapper>
    </FormProvider>
  )
}
